/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../services/commonService";


const initialState = {
    data:[],
    status:true,
    config:[],
    deviceId:"",
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        addUser(state, action){
            return {
                ...state,
                data:{
                    ...state.data,  ...action.payload
                },
            }
        },
        updateDeviceId(state, action){
            return {
                ...state,
                deviceId: action.payload
            }
        }
    },
    extraReducers: (builder) =>{
        builder
        .addCase(getLoginUserData.pending, (state,action)=>{
            state.status = false
        })
        .addCase(getLoginUserData.fulfilled, (state,action)=>{
            state.data = action.payload?.data;
            state.status = true;
        })
        .addCase(getLoginUserData.rejected, (state,action)=>{
            state.status = false;
        })
    }
  });

export const { addUser, updateDeviceId} = userSlice.actions;
export default userSlice.reducer;

export const getLoginUserData = createAsyncThunk('loginUser', async () =>{
    console.log(">> loaded LoginUserData");
    const res = await ItemService.getLoginUserData();
    return res;
})

